import axios from 'axios'
class studentCourseService {
  updateStudentCourseTermOrder(course_name, studentCourseChange, token) {
    if (studentCourseChange.positionAddDate === undefined) {
      studentCourseChange.positionAddDate = ''
    }
    return new Promise(async (resolve, reject) => {
      await fetch(
        `${process.env.REACT_APP_BACKEND_URL}api/v1/studentCourses/${course_name}/termOrder`,
        {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            token: token,
          },
          body: JSON.stringify({ studentCourseChange }),
        },
      )
        .then((data) => resolve(data.json()))
        .catch((err) => reject(err))
    })
  }

  getStudentCourseByCourseName({ course_name, token, sort, passQualified }) {
    let url = `${process.env.REACT_APP_BACKEND_URL}api/v1/studentCourses/${course_name}/students`
    url += `?sort=${sort}&passQualified=${passQualified}`
    return new Promise(async (resolve, reject) => {
      await fetch(url, {
        method: 'GET',
        headers: {
          token: token,
        },
      })
        .then((data) => resolve(data.json()))
        .catch((err) => reject(err))
    })
  }

  getStudentCourseReportByCourseName({ course_name, token }) {
    return new Promise(async (resolve, reject) => {
      await fetch(
        `${process.env.REACT_APP_BACKEND_URL}api/v1/studentCourses/${course_name}/report`,
        {
          method: 'GET',
          headers: {
            token: token,
          },
        },
      )
        .then((data) => resolve(data.json()))
        .catch((err) => reject(err))
    })
  }

  getStudentCourseById(id, token) {
    return new Promise(async (resolve, reject) => {
      await fetch(
        `${process.env.REACT_APP_BACKEND_URL}api/v1/studentCourses/${id}`,
        {
          method: 'GET',
          headers: {
            token: token,
          },
        },
      )
        .then((data) => resolve(data.json()))
        .catch((err) => reject(err))
    })
  }

  getStudentCourseConfirmationByCourseNameAndAirforceId(
    course_name,
    airforce_id,
    token,
  ) {
    return new Promise(async (resolve, reject) => {
      await fetch(
        `${process.env.REACT_APP_BACKEND_URL}api/v1/studentCourses/course/${course_name}/airforceId/${airforce_id}/confirmation`,
        {
          method: 'GET',
          headers: {
            token: token,
          },
        },
      )
        .then((data) => resolve(data.json()))
        .catch((err) => reject(err))
    })
  }

  getCourseByCitizenId(citizenId, token) {
    return new Promise(async (resolve, reject) => {
      await fetch(
        `${process.env.REACT_APP_BACKEND_URL}api/v1/studentCourses/${citizenId}/courses`,
        {
          method: 'GET',
          headers: {
            token: token,
          },
        },
      )
        .then((data) => resolve(data.json()))
        .catch((err) => reject(err))
    })
  }

  createStudentCourseByCourseId(data, token) {
    console.log('data :>> ', data)
    return new Promise(async (resolve, reject) => {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}api/v1/studentCourses`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          token: token,
        },
        body: JSON.stringify({ ...data }),
      })
        .then((data) => resolve(data.json()))
        .catch((err) => reject(err))
    })
  }

  updateStudentCourseScoreById(id, data, token) {
    return new Promise(async (resolve, reject) => {
      await fetch(
        `${process.env.REACT_APP_BACKEND_URL}api/v1/studentCourses/${id}/score`,
        {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            token: token,
          },
          body: JSON.stringify({ ...data }),
        },
      )
        .then((data) => resolve(data.json()))
        .catch((err) => reject(err))
    })
  }

  updateStudentCourseTermChose(id, data, token) {
    return new Promise(async (resolve, reject) => {
      await fetch(
        `${process.env.REACT_APP_BACKEND_URL}api/v1/studentCourses/${id}/termChose`,
        {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            token: token,
          },
          body: JSON.stringify(data),
        },
      )
        .then((data) => resolve(data.json()))
        .catch((err) => reject(err))
    })
  }

  updateStudentCourseTermSortById(id, data, token) {
    return new Promise(async (resolve, reject) => {
      await fetch(
        `${process.env.REACT_APP_BACKEND_URL}api/v1/studentCourses/${id}/termSort`,
        {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            token: token,
          },
          body: JSON.stringify({ ...data }),
        },
      )
        .then((data) => resolve(data.json()))
        .catch((err) => reject(err))
    })
  }

  uploadEclScore(courseId, file, token) {
    return new Promise(async (resolve, reject) => {
      const request = new FormData()
      request.append('file', file)
      axios
        .post(
          `${process.env.REACT_APP_BACKEND_URL}api/v1/studentCourses/course/${courseId}/eclImport`,
          request,
          { headers: { token: token } },
        )
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err.response.data)
        })
    })
  }

  uploadHealthFile(courseId, file, token) {
    return new Promise(async (resolve, reject) => {
      const request = new FormData()
      request.append('file', file)
      axios
        .post(
          `${process.env.REACT_APP_BACKEND_URL}api/v1/studentCourses/course/${courseId}/healthImport`,
          request,
          { headers: { token: token } },
        )
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err.response.data)
        })
    })
  }

  uploadFinalTermFile(courseId, file, token) {
    return new Promise(async (resolve, reject) => {
      const request = new FormData()
      request.append('file', file)
      axios
        .post(
          `${process.env.REACT_APP_BACKEND_URL}api/v1/studentCourses/course/${courseId}/finalTermImport`,
          request,
          { headers: { token: token } },
        )
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err.response.data)
        })
    })
  }

  uploadAllImportFile(courseId, file, token) {
    return new Promise(async (resolve, reject) => {
      const request = new FormData()
      request.append('file', file)
      axios
        .post(
          `${process.env.REACT_APP_BACKEND_URL}api/v1/studentCourses/course/${courseId}/allImport`,
          request,
          { headers: { token: token } },
        )
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err.response.data)
        })
    })
  }

  arrangeTerm(courseId, token, role) {
    return new Promise(async (resolve, reject) => {
      await fetch(
        `${process.env.REACT_APP_BACKEND_URL}api/v1/studentCourses/course/${courseId}/arrangeTerm`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            token: token,
          },
          body: JSON.stringify({ role }),
        },
      )
        .then((data) => resolve(data.json()))
        .catch((err) => reject(err))
    })
  }

  approveStudentCourse(courseId, token) {
    return new Promise(async (resolve, reject) => {
      await fetch(
        `${process.env.REACT_APP_BACKEND_URL}api/v1/studentCourses/${courseId}/approve`,
        {
          method: 'PATCH',
          headers: {
            token: token,
          },
        },
      )
        .then((data) => resolve(data.json()))
        .catch((err) => reject(err))
    })
  }

  clearStudentCourseSortByCourseName({ course_name, token }) {
    let url = `${process.env.REACT_APP_BACKEND_URL}api/v1/studentCourses/${course_name}/students/sort`
    return new Promise(async (resolve, reject) => {
      await fetch(url, {
        method: 'PATCH',
        headers: {
          token: token,
        },
      })
        .then((data) => resolve(data.json()))
        .catch((err) => reject(err))
    })
  }

  getEclInHRISByCourseId(course_id, token) {
    let url = `${process.env.REACT_APP_BACKEND_URL}api/v1/studentCourses/${course_id}/eclHris`
    return new Promise(async (resolve, reject) => {
      await fetch(url, {
        method: 'GET',
        headers: {
          token: token,
        },
      })
        .then((data) => resolve(data.json()))
        .catch((err) => reject(err))
    })
  }

  getHealthInHRISByCourseId(course_id, token) {
    let url = `${process.env.REACT_APP_BACKEND_URL}api/v1/studentCourses/${course_id}/healthHris`
    return new Promise(async (resolve, reject) => {
      await fetch(url, {
        method: 'GET',
        headers: {
          token: token,
        },
      })
        .then((data) => resolve(data.json()))
        .catch((err) => reject(err))
    })
  }

  generatePmeReportOrderByCourseName({ course_name, token, spcNo }) {
    let url = `${process.env.REACT_APP_BACKEND_URL}api/v1/reports/${course_name}/pmeReportOrder`
    return new Promise(async (resolve, reject) => {
      await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          token: token,
        },
        body: JSON.stringify({ spcNo }),
      })
        .then((data) => resolve(data.json()))
        .catch((err) => reject(err))
    })
  }

  generateeResultOrderByCourseName(body) {
    const { course_name, isAdminReq, token } = body

    let url = `${
      process.env.REACT_APP_BACKEND_URL
    }api/v1/reports/${course_name}/${
      isAdminReq ? 'resultOrderAdmin' : 'resultOrder'
    }`
    return new Promise(async (resolve, reject) => {
      await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          token: token,
        },
        body: JSON.stringify(body),
      })
        .then((data) => resolve(data.json()))
        .catch((err) => reject(err))
    })
  }

  deleteStudentCourseById(id, token) {
    return new Promise(async (resolve, reject) => {
      await fetch(
        `${process.env.REACT_APP_BACKEND_URL}api/v1/studentCourses/${id}`,
        {
          method: 'DELETE',
          headers: {
            token: token,
          },
        },
      )
        .then((data) => resolve(data.json()))
        .catch((err) => reject(err))
    })
  }
}

export default studentCourseService
